import attorneyCandidate from "./attorney-candidate";

const getHtml = ({ candidateInfo, base64Logo, base64Photo }) => {
  return attorneyCandidate.generateHtml(candidateInfo, base64Logo, base64Photo);
};

export default { getHtml };
